import React from 'react';
import { useText } from '../../lib/siteContent';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { responsiveImg } from '../../lib/imageUrl';
import { useSlotImage } from '../../lib/useSlotImage';
import { UNIVERSES } from '../../lib/universes';
import { TextLink } from './TextLink';

const OFFSETS = ['lg:mt-28', 'lg:mt-0', 'lg:mt-28'];

const UniverseColumn = ({ u, index }) => {
  const image = useSlotImage(u.slot, u.fallback);
  const t = useText();
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 1.1, delay: index * 0.15, ease: [0.22, 1, 0.36, 1] }}
      className={`flex flex-col ${OFFSETS[index]}`}
      data-testid={`univers-col-${u.slug}`}
    >
      <Link to={`/univers/${u.slug}`} className="block aspect-[3/4] overflow-hidden bg-[#F5F5F5] group" data-testid={`univers-image-link-${u.slug}`}>
        <img
          {...responsiveImg(image, '(max-width: 768px) 100vw, 33vw')}
          alt={`${t(`univers.${u.slug}.title`)} — image d'illustration`}
          className="w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.03]"
        />
      </Link>
      <span className="mt-8 text-[11px] tracking-[0.3em] text-[#6B6B6B]">{u.n}</span>
      <h3 className="mt-3 font-serif font-light text-[#111111] text-3xl md:text-[2.1rem] leading-[1.15]">{t(`univers.${u.slug}.title`)}</h3>
      <p className="mt-4 text-sm leading-[1.85] font-light text-[#333333] max-w-xs">{t(`univers.${u.slug}.desc`)}</p>
      <div className="mt-8">
        <TextLink to={`/univers/${u.slug}`} testId={`univers-cta-${u.slug}`}>Découvrir</TextLink>
      </div>
    </motion.article>
  );
};

const UniversSection = () => {
  const t = useText();
  return (
  <section id="univers" className="bg-[#FFFFFF] pt-8 pb-32 md:pb-48" data-testid="univers-section">
    <div className="container-custom">
      <div className="mb-20 md:mb-28">
        <span className="block text-[11px] uppercase tracking-[0.3em] text-[#111111] mb-8">{t('univers.label')}</span>
        <h2 className="font-serif font-light text-[#111111] text-5xl sm:text-6xl lg:text-7xl leading-[1.02]" data-testid="univers-headline">
          <span className="whitespace-pre-line">{t('univers.headline')}</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-20 md:gap-8 lg:gap-12 xl:gap-16">
        {UNIVERSES.map((u, i) => <UniverseColumn key={u.slug} u={u} index={i} />)}
      </div>
    </div>
  </section>
  );
};

export default UniversSection;
